var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tarefas',{staticClass:"task-layout-inline",attrs:{"layout":"inline","relacao-entidade":"bem","relacao-entidade-id":_vm.bem.id,"tags":['negociacao']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }